var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.paths.length !== 0)?_c('GmapPolygon',{attrs:{"editable":_vm.editable,"options":_vm.options,"paths":_vm.paths},on:{"click":_vm.handleClick}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }